import { Link } from "react-router-dom";
import { useUser } from "../store";
import { toSlug } from "common";
import "./Facilities.scss";

export const Facilities = () => {
  const { user } = useUser();
  const facilities = user?.facilities ?? [];

  return (
    <main className="content facilities-page">
      <header className="facilities-heading">
        <div>
          <span className="facilities-eyebrow">Workspace</span>
          <h1>My facilities</h1>
          <p>Select a facility to view its payers and aging reports.</p>
        </div>
        <span className="facilities-count">
          <strong>{facilities.length}</strong>
          {facilities.length === 1 ? " facility" : " facilities"}
        </span>
      </header>

      {facilities.length ? (
        <nav className="facilities-grid" aria-label="My facilities">
          {facilities.map((facility) => (
            <Link
              key={facility}
              to={`/${toSlug(user.group)}/${toSlug(facility)}`}
              className="facility-card"
            >
              <span className="facility-card-icon" aria-hidden="true">
                <i className="fa-solid fa-building" />
              </span>
              <span className="facility-card-name capitalize">{facility}</span>
              <span className="facility-card-description">View facility reports</span>
              <i className="fa-solid fa-arrow-right facility-card-arrow" aria-hidden="true" />
            </Link>
          ))}
        </nav>
      ) : (
        <section className="facilities-empty-state">
          <span className="facility-card-icon" aria-hidden="true">
            <i className="fa-solid fa-building" />
          </span>
          <h2>No facilities assigned</h2>
          <p>Contact your administrator to request access to a facility.</p>
        </section>
      )}
    </main>
  );
};
